<template>

  <el-dialog
    title="Просмотр данных пациента"
    :visible="visible"
    :before-close="close"
    :width="'80%'"
    @opened="onOpen"
    @open="loading = !!1"
  >

    <el-form ref="editForm" :rules="editFormRules" :model="editForm" v-loading="loading">
      <el-form-item label="Имя" prop="name" :error="errors.name | errorToSrt">
        <el-input name="name" ref="autoFocus" placeholder="Введите имя" v-model="editForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Телефон" prop="phone" :error="errors.phone | errorToSrt">
        <el-input v-mask="'+7-###-###-##-##'"
                  placeholder="+7-xxx-xxx-xx-xx"
                  auto-complete="off"
                  name="phone"
                  v-model="editForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="E-mail" prop="email" :error="errors.email | errorToSrt">
        <el-input name="email" placeholder="Email адрес" v-model="editForm.email"></el-input>
      </el-form-item>
      <el-form-item label="Возраст" prop="age" :error="errors.age | errorToSrt">
        <el-input name="age" placeholder="Введите возраст" v-model="editForm.age"></el-input>
      </el-form-item>

      <!--                    <el-form-item class="modal-body__btns">-->
      <!--                      <el-button-->
      <!--                        type="primary"-->
      <!--                        :loading="loadBtn"-->
      <!--                        @click="saveForm"-->
      <!--                      >Сохранить</el-button>-->
      <!--                    </el-form-item>-->
    </el-form>

  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'DialogWorkerEdit',
  data () {
    return {
      form: null,
      error: null,
      loading: false,
      loadBtn: false,
      errors: {},
      editForm: {},
      genderList: {},
      editFormRules: {
        name: [
          { required: true, message: 'Укажите имя', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите тип', trigger: 'blur' }],
        compendium: [
          { required: true, message: 'Выберите тип', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  props: {
    user: {
      default: true
    },
    visible: {
      required: true
    }
  },
  filters: {
    errorToSrt (t) {
      return t ? t.join(', ') : null
    }
  },
  methods: {
    onOpen () {
      this.loadLogic()
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    loadLogic () {
      this.loading = !!1
      this.$api.users
        .get(this.user)
        .then((response) => {
          this.editForm = response.data
        })
        .catch(() => {
          this.loading = !!0
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {

        })

      this.loadGender()
      this.autoFocus()
    },
    generatePassword () {
      Vue.set(this.addForm, 'password', Math.random().toString(36).slice(-8))
      this.$refs.password.passwordVisible = !!1
    },
    loadGender () {
      this.loading = !!1
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loading = !!0
        })
    },
    saveForm (close) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadBtn = !!1

          const payLoad = {
            type: this.editForm.type,
            schema: {
              text: this.editForm.name,
              compendium: this.editForm.compendium
            }
          }
          this.$api.worker
            .edit(this.worker.id, payLoad)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.editForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadBtn = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  &__mask {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.modal-content {
  max-width: 700px;
  height: 90%;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-body {
  max-width: 960px;
  margin: 20px auto;

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;

  &__icon {
    float: right;
    cursor: pointer;
  }
}

.modal-footer {
  padding: 40px 0;

  &__button {
    float: right;
  }
}
</style>
